
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BatchResponseTypeBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BatchResponseType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"batchId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reporterId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"batchHeaderResponse"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"batchStatisticsResponse"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"published"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"responded"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":156}};
    doc.loc.source = {"body":"fragment BatchResponseTypeBase on BatchResponseType {\n  id\n  batchId\n  reporterId\n  batchHeaderResponse\n  batchStatisticsResponse\n  published\n  responded\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
